import Page from "../../../../src/components/layouts/Page";
import React from 'react';
export default {
  Page,
  React
};